import React, { createContext, useState, useEffect } from "react";
import useFetch from "../../hooks/useFetch";

export const SuppliersContext = createContext();
SuppliersContext.displayName = "Supplier List Context";

export const SuppliersContextProvider = (props) => {
  const [suppliers, setSuppliers] = useState([]);
  const [maxPagination, setMaxPagination] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [latestQuery, setLatestQuery] = useState({});
  const [isLoadingSuppliers, setIsLoadingSuppliers] = useState(true);
  const { get, post, put } = useFetch();

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => getSuppliers();

  const getSuppliers = async (queries = {}) => {
    setIsLoadingSuppliers(true);
    setLatestQuery(queries);
    let url = "/suppliers?";

    Object.keys(queries).forEach(function (key, index) {
      url += key + "=" + queries[key] + "&";
    });

    get(url)
      .then((res) => {
        setSuppliers(res);
        setMaxPagination(res.total);
        setCurrentPage(Number(res.page));
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setIsLoadingSuppliers(false));
  };

  const addSupplier = (newSupplier) => {
    return new Promise((resolve, reject) => {
      post("/suppliers", newSupplier)
        .then(async () => {
          getSuppliers();
          resolve(true);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const updateSupplier = (supplierId, params) => {
    return new Promise((resolve, reject) => {
      put(`/suppliers/${supplierId}`, params)
        .then(async (res) => {
          await getSuppliers();
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const setPagination = (page) => {
    let newQuery = { ...latestQuery };
    newQuery.page = page;
    getSuppliers(newQuery);
  };

  return (
    <SuppliersContext.Provider
      value={{
        suppliers,
        setSuppliers,
        updateSupplier,
        addSupplier,
        getSuppliers,
        setPagination,
        maxPagination,
        currentPage,
        isLoadingSuppliers,
      }}
    >
      {props.children}
    </SuppliersContext.Provider>
  );
};
